import React from 'react'

class Image extends React.Component {
	constructor(props) {
		super(props)
		this.state = { loading: true, loaded: false }
	}

	handleImageLoaded() {
		this.setState({ loading: false, loaded: true })
	}

	handleImageErrored() {
		this.setState({ loading: false, loaded: false })
	}

	render() {
		// const { props } = this.props
		return (
			<img
				{...this.props}
				style={{
					...this.props.style,
					opacity: this.state.loading ? '0' : '1',
					transition: 'opacity .3s ease-out'
				}}
				role={'presentation'}
				onLoad={this.handleImageLoaded.bind(this)}
				onError={this.handleImageErrored.bind(this)}
			/>
		)
	}
}

export default Image



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Image/Image.js